import { NgModule, inject } from '@angular/core';
import { throwIfAlreadyLoaded } from '@core/module-import-guard';
import { environment } from '@env/environment';
import {
  API_BASE_URL,
  FileClient,
  IncidentClient,
  OfferingClient,
  OptionSetClient,
  LocationClient,
  QuoteClient,
  TaskClient,
  WorkorderClient,
  EquipmenmtClarificationClient,
  CustomizableTextClient,
  RepresentativeClient,
} from './smart-portal.api';

const PROVIDERS = [
  { provide: API_BASE_URL, useFactory: () => environment.baseUrl },
  OfferingClient,
  IncidentClient,
  FileClient,
  TaskClient,
  OptionSetClient,
  LocationClient,
  QuoteClient,
  WorkorderClient,
  EquipmenmtClarificationClient,
  CustomizableTextClient,
  RepresentativeClient,
];

@NgModule({
  declarations: [],
  imports: [],
  providers: [...PROVIDERS],
})
export class SmartPortalApiModule {
  constructor() {
    const parentModule = inject(SmartPortalApiModule, { optional: true, skipSelf: true });

    throwIfAlreadyLoaded(parentModule, 'SmartPortalApiModule');
  }
}
